import Vue from 'vue';
//    ┏┓   ┏┓
//  ┏┛┻━━┛┻┓
//  ┃          ┃
//  ┃   ━     ┃
//  ┃ ┳┛ ┗┳ ┃
//  ┃          ┃
//  ┃   ┻     ┃
//  ┃          ┃
//  ┗━┓   ┏━┛
//     ┃   ┃
//     ┃   ┃
//     ┃   ┗━━━┓
//     ┃         ┣┓
//     ┃          ┏┛
//     ┗┓┓┏━┳┓┏┛
//       ┃┫┫ ┃┫┫
//       ┗┻┛ ┗┻┛
// Codes are far away from bugs with the animal protecting
// 神兽保佑,代码无bug
import * as AppBaseConfigService from '@/storage/services/AppBaseConfigService'
import * as HotelcemCommonFilterService from '@/storage/services/hotelcem/CommonFilterService'
import { LoginService } from 'voc-service'
// import LoginAPI from '@/xreports/apis/system/login'
import UserAPI from '@/xreports/apis/system/user'
// import * as SQAPPUtil from '@/xreports/utils/SQAPPUtil'
import { messageBox } from '@/utils/VocMessageBox'

    import { TenantBaseConfig } from './app'

    
    let _i18n_vue = new Vue();
    const $t = _i18n_vue.$t.bind(_i18n_vue);
    

let isRms = window.location.href.includes('rms.')
let loginService
function getLoginService() {
  if (!loginService) {
    const config = {
      env: process.env.VUE_APP_ENV,
      appName: isRms ? 'rms' : AppBaseConfigService.getAppBaseConfig().appName,
    }
    loginService = new LoginService(config)
  }
  return loginService
}

const user = {
  namespaced: true,
  state: {
    token: undefined,
    ssoToken: undefined,
    userInfo: undefined,
    loginSsoToken: undefined,
  },
  mutations: {
    setLoginSSOToken(state, loginSsoToken) {
      state.loginSsoToken = loginSsoToken
      AppBaseConfigService.setLoginSSOToken(loginSsoToken)
    },
    setSSOToken(state, ssoToken) {
      state.ssoToken = ssoToken
      AppBaseConfigService.setSSOToken(ssoToken)
    },
    setToken(state, tokenInfo) {
      state.token = tokenInfo.access_token
      AppBaseConfigService.setToken(tokenInfo.access_token)
    },
    setUserInfo(state, userInfo) {
      state.userInfo = {
        ...state.userInfo,
        ...userInfo,
      }
      AppBaseConfigService.setUserInfo(state.userInfo)
    },
  },
  actions: {
    /**
     * 检查登录
     */
    async checkLogin({ commit, dispatch }) {
      try {
        const loginService = getLoginService()
        let entity = {}
        const reg = new RegExp(process.env.VUE_APP_REDIRECT_CASURL)

        let resObj = {}
        const pList = new URLSearchParams(location.search)
        pList.forEach((val, key) => {
          resObj[key] = val
        })
        // 获取当前导航类型
        const navType = performance.getEntriesByType('navigation')[0]?.type
        if (
          (reg.test(document.referrer) || resObj.loginType === 'openapi') &&
          navType !== 'reload'
          // 来源于第三方的实则每次都应该走登陆，不然一换号就串。
        ) {
          console.info('login')
          entity = await loginService.login()
        } else {
          console.info('getAppBaseInfo')
          entity = await loginService.getAppBaseInfo()
        }
        // 已登录
        if (entity.ssoToken && entity.token && entity.userInfo && entity.userInfo.account && entity.userInfo.realName) {
          commit('setLoginSSOToken', entity.loginSsoToken)
          commit('setSSOToken', entity.ssoToken)
          commit('setToken', { access_token: entity.token, expires_in: 5445646 })
          commit('setUserInfo', entity.userInfo)
          // setUserInfo一定要执行两次, 第一次是存储token相关信息, 第二次是刷新logo
          UserAPI.fetchTenantDetail().then(data => {
            entity.userInfo.brand = data?.logoUrl
            entity.userInfo.tenantName = data?.tenantName
            entity.userInfo.isOpenVoiceTenant = data?.isOpenVoice
            commit('setUserInfo', entity.userInfo)
            commit('app/SET_INFO_BY_TENANT', data?.tenantId, { root: true })
            commit('common/SET_TENANTINFO', data, { root: true })
          })

          window.localStorage.wmUserInfo = JSON.stringify({
            userId: entity.userInfo.account,
            userTag: entity.userInfo.tenantId,
            // projectVersion: '1.0.1',
            // secondUserParam: entity.userInfo.userName,
            nickname: entity.userInfo.userName,
          })
          return Promise.resolve()
        }
        return Promise.reject('loginExpired')
      } catch (e) {
        console.info('errot', e)
        // if (SQAPPUtil.isSQ_App()) {
        //   return dispatch('loginFromSQAPP')
        // }
        return dispatch('logout', { logoutType: e })
      }
    },
    /**
     * 登录上汽APP
     */
    // async loginFromSQAPP({ commit }) {
    //   try {
    //     const sign = await LoginAPI.getSQAPPSignature('xreports')
    //     const code = await SQAPPUtil.registerJSSDK(sign)
    //     const ticket = await LoginAPI.getSystemTicket(code)
    //     const entity = await LoginAPI.loginByTicket(ticket)
    //     if (entity?.access_token) {
    //       // commit('setSSOToken', entity.access_token)
    //       commit('setToken', { access_token: entity.access_token })
    //     }
    //     const userInfo = await UserAPI.getUserInfo()
    //     if (userInfo && userInfo.account && userInfo.realName) {
    //       commit('setUserInfo', userInfo)
    //       window.localStorage.wmUserInfo = JSON.stringify({
    //         userId: userInfo.account,
    //         userTag: userInfo.tenantId,
    //         projectVersion: '1.0.1',
    //         secondUserParam: userInfo.userName,
    //       })
    //     }
    //     return Promise.resolve()
    //   } catch (error) {
    //     console.error(error)
    //     return dispatch('logout', { logoutType: e })
    //   }
    // },
    /**
     * 退出登录
     */
    async logout({ dispatch }, payload) {
      console.warn('logout', payload)
      const isMh = document.referrer && document.referrer.includes('https://mh')
      const isJJhqm = location.href.startsWith('https://jjhqm')

      if (payload?.userLogout) {
        // 用户主动退出
        const loginService = getLoginService()
        const service = payload?.from || location.href
        // 清除酒店CEM查询条件
        HotelcemCommonFilterService.clearHotelCemFilter()
        HotelcemCommonFilterService.clearHotelCemDefault()
        // 清除语言设置
        localStorage.removeItem('VOC-LANGUAGE')
        // 退出登录
        let tenantId = AppBaseConfigService.getUserInfo()?.tenantId
        // 清除应用信息
        AppBaseConfigService.clearAppBaseConfig()

        let loginDomain
        const config = TenantBaseConfig[process.env.VUE_APP_ENV]?.[tenantId]
        // 判断超级酒店配置
        if (config && config.loginDomain) {
          loginDomain = config.loginDomain
        } else if (isMh) {
          // 如果是超级酒店登录页跳转且没有权限时
          loginDomain = 'https://mh.vocust.com'
        }
        loginService.logout({ service, loginDomain })
      } else {
        const lang = localStorage.getItem('VOC-LANGUAGE') === 'en' ? '/en-US' : ''
        const logoutType = payload?.logoutType

        // 无数据权限 httpCode 401 || responseCode 403
        let messageOption = {
          confirmButtonText: $t('204ffa'),
          message: $t('8681fa'),
          title: $t('daaaeb'),
          showCancelButton: false,
        }
        let url
        if (logoutType === 'ticket error' || logoutType === 'loginExpired') {
          // 用户未登录
          messageOption = { ...messageOption, confirmButtonText: $t('d25a9b'), message: $t('d979e1') }
        } else if (logoutType === 'ssoToken error') {
          // 没有当前应用权限
          // if (AppBaseConfigService.getAppBaseConfig().appName === 'xreports') {
          //   messageOption.message = '您的账号没有系统访问权限，如需开通，请联系华客业务人员。'
          // } else {
          //   messageOption.message = '您的账号没有系统访问权限，如需开通，请联系华客业务人员。'
          // }
          messageOption.message = $t('8612c8')
          url = `${isMh ? 'https://mh.vocust.com' : process.env.VUE_APP_REDIRECT_CASURL}${lang}/#/system-select`
          url = isJJhqm ? process.env.VUE_APP_JJHQM_LOGIN : url
        } else if (logoutType === 'no hotelcem auth') {
          messageOption.message = $t('c65881')
          url = `${isMh ? 'https://mh.vocust.com' : process.env.VUE_APP_REDIRECT_CASURL}${lang}/#/system-select`
          url = isJJhqm ? process.env.VUE_APP_JJHQM_LOGIN : url
        }

        await messageBox(messageOption).catch(() => {})
        if (url) {
          location.href = url
        } else {
          return dispatch('logout', { userLogout: true })
        }
      }
    },
  },
}

export default user
